import { ApriorMapRead, ApriorMapVersionRead, MainService } from 'api/schema'
import { APRIOR_MAP_STATUS } from 'utils/constants'
import { IApriorMap, IApriorMapVersion } from 'utils/interfaces'
import { toApriorMapId, toApriorMapVersionId, type ApriorMapVersionId } from 'utils/types'

export const normalizeApriorMapVersion = (versionRaw: ApriorMapVersionRead): IApriorMapVersion => {
  return {
    id: toApriorMapVersionId(versionRaw.id),
    name: versionRaw.name || '',
    version: versionRaw.version,
    status: versionRaw.status as unknown as APRIOR_MAP_STATUS,
    tifUrl: versionRaw.tif_url || null,
    ovrUrl: versionRaw.ovr_url || null,
  }
}

export const normalizeApriorMap = (mapRaw: ApriorMapRead): IApriorMap => {
  return {
    id: toApriorMapId(mapRaw.id),
    name: mapRaw.name || '',
    lastVersionId: mapRaw.last_version_id ? toApriorMapVersionId(mapRaw.last_version_id) : undefined,
    versions: (mapRaw.versions || []).map(v => normalizeApriorMapVersion(v)),
  }
}

export const ApriorMapApi = {
  getAll: async (): Promise<IApriorMap[]> => {
    const maps: IApriorMap[] = []
    let page = 1
    let hasNextPage = true

    while (hasNextPage) {
      const response = await MainService.mainApriorMapList(undefined, page, 1000)
      maps.push(...(response.results || []).map(normalizeApriorMap))
      hasNextPage = !!response.page_next
      page += 1
    }

    return maps
  },
}

export const findApriorMapVersion = (
  maps: IApriorMap[],
  versionId: ApriorMapVersionId | null | undefined
): IApriorMapVersion | undefined => {
  if (!versionId) return undefined
  for (const map of maps) {
    const version = map.versions.find(v => v.id === versionId)
    if (version) return version
  }
  return undefined
}
